import NiceModal from '@ebay/nice-modal-react';
import ModalCloudflare from './modal-cloudflare';

export const showModalCloudflare = () => {
  return NiceModal.show(ModalCloudflare);
};